import { render, staticRenderFns } from "./AMeasureProcessStepQuestion.vue?vue&type=template&id=131e4b85&"
import script from "./AMeasureProcessStepQuestion.vue?vue&type=script&lang=ts&"
export * from "./AMeasureProcessStepQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports